import { Injectable } from "@angular/core";

import { GroupOffer } from "../../interfaces";

import { GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class GroupOffersService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "groupoffers/";
  }

  add(body: GroupOffer) {
    return this.post<boolean>({ APIName: "add", body, showAlert: true });
  }

  update(body: GroupOffer) {
    return this.put<boolean>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<GroupOffer>({ APIName: `get-id/${id}` });
  }

  getPaged(body: GetPagedBody<Partial<GroupOffer>>) {
    return this.getPagedRequest<GroupOffer[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<GroupOffer[]>({ APIName: "getall" });
  }
}
